import { format } from 'date-fns';
import React, { useEffect, useState, Suspense } from 'react';
import { CheckBox } from 'devextreme-react/check-box';
import NumberBox from 'devextreme-react/number-box';
import TextBox from 'devextreme-react/text-box';
import { DateBox, LoadIndicator, SelectBox } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import { LoadPanel } from 'devextreme-react/load-panel';
import { modalErrorOpen } from '../store/actions/modalError';
import HolderReportCell from '../components/Reports/HolderReportCell';
import ZDVLLineIcon from '../components/RecyclingOrders/ZDVLLineIcon';
import style from './functions.module.scss';
import * as dayjs from 'dayjs';

export function isOne(tempArray = [], cellName = 'name', plantId = 0) {
  const temp = new Set();
  tempArray.forEach((item) => {
    if (item[cellName]) {
      if (plantId === 0) {
        temp.add(item[cellName].toUpperCase().trim());
      } else {
        temp.add(item[cellName]);
      }
    }
  });
  return Array.from(temp).length <= 1;
}

export function isOneFlag(tempArray = [], cellName = 'name') {
  // eslint-disable-next-line no-shadow
  let isOne = null;
  let curValue = null;
  tempArray.forEach((item) => {
    if (curValue == null || curValue === item[cellName]) {
      curValue = item[cellName];
      isOne = true;
    } else {
      isOne = false;
    }
  });
  return isOne;
}

export function isOneQCShipment(tempArray = [], cellName = 'name') {
  // eslint-disable-next-line no-shadow
  let isLPC3 = false;
  let isOther = false;
  tempArray.forEach((item) => {
    if (item[cellName] === 1075) {
      isLPC3 = true;
    } else {
      isOther = true;
    }
  });
  return (isLPC3 && isOther);
}

export const trim = (s, c) => {
  if (s === '' || s === null) {
    return '';
  }
  // eslint-disable-next-line no-param-reassign
  if (c === ']') c = '\\]';
  // eslint-disable-next-line no-param-reassign
  if (c === '\\') c = '\\\\';
  try {
    return s.replace(new RegExp(`^[${c}]|[${c}]+$`, 'g'), '');
  } catch (e) {
    return s;
  }
};

export const replaceString = (value) => {
  if (value !== null) {
    return value
      .replace(/\n/g, ',')
      .replace(/\r/g, ',')
      .replace(/\t/g, ',')
      .replace(/\s+/g, ',')
      .replace(/(,+)/g, ';')
      .replace(/\s+/g, '');
  }
  return null;
};

/** Рендер некоторых полей */
export const cellRenderParseData = (data) => {
  if (!data.value) {
    return '';
  }
  try {
    const timeD = Date.parse(data.value);
    return format(timeD, 'dd.MM.yyyy');
  } catch (e) {
    console.log('Error data format: ', data.value);
  }
  return '';
};

export const cellRenderParseDataAndTime = (data) => {
  if (!data.value) {
    return '';
  }
  try {
    const timeD = Date.parse(data.value);
    return format(timeD, 'dd.MM.yyyy, HH:mm');
  } catch (e) {
    console.log('Error data format: ', data.value);
  }
  return '';
};

export const cellRenderParseDataAndTimeWithSeconds = (data) => {
  if (!data.value) {
    return '';
  }
  try {
    const timeD = Date.parse(data.value);
    return format(timeD, 'dd.MM.yyyy HH:mm:ss');
  } catch (e) {
    console.log('Error data format: ', data.value);
  }
  return '';
};

export const cellRenderHolderReportGrid = (data) => <HolderReportCell data={data} />;

export const sleep = (time) => new Promise((resolve) => {
  setTimeout(() => { resolve(); }, time);
});

/** Рендер некоторых палей */
// todo Поменять на id
export const cellRenderStatus = (data) => {
  if (data.value === 'В пути' || data.value === 1) {
    return (<div className={'colorIcon'}><span>{data.value}</span></div>);
  }
  if (data.value === 'В пути' || data.value === 2) {
    return (<div className={'colorGreen'}><span>{data.value}</span></div>);
  }
  if (data.value === 'В наличии') {
    return (<div className={'colorMain'}><span>{data.value}</span></div>);
  }
  if ((data.value === 'Отгружен' || data.value === -1) || data.value === 'Выкуплен' || data.value === 'Переработан') {
    return (<div className={'colorRed'}><span>{data.value}</span></div>);
  }
  if (data.value === 'В переработке' || data.value === 'Частично отгружен' || data.value === 'На оформлении') {
    return (<div className={'colorOrange'}><span>{data.value}</span></div>);
  }
  return (<div className={'colorIcon'}><span>{data.value}</span></div>);
};

export const cellRenderAdminMessageStatus = ({ data }) => {
  if (data.status === 1) {
    return (<div className={'colorIcon'}><span>{data.statusDesc}</span></div>);
  } else if (data.status === 2) {
    return (<div className={'colorGreen'}><span>{data.statusDesc}</span></div>);
  } else if (data.status === -1) {
    return (<div className={'colorRed'}><span>{data.statusDesc}</span></div>);
  } else if (data.status !== -1 || data.status !== 1 || data.status !== 2) {
    return (<div className={'colorOrange'}><span>{data.statusDesc}</span></div>);
  }
  return (<div>{data.statusDesc}</div>);
}

export const cellSORenderStatus = (data) => {
  if (data.value === 'Принята') {
    return (<div className={'colorGreen'}><span>{data.value}</span></div>);
  }
  if (data.value === 'Создана') {
    return (<div className={'colorYellow'}><span>{data.value}</span></div>);
  }
  if (data.value === 'Отменена') {
    return (<div className={'colorIcon'}><span>{data.value}</span></div>);
  }
  if (data.value === 'Закрыта') {
    return (<div className={'colorRed'}><span>{data.value}</span></div>);
  }
  return (<div>{data.value}</div>);
};

/** Рендер некоторых статусов актов */
export const cellRenderStatusAct = (data) => {
  if (data.data) {
    if (data.data.mh1DocStatusDescr && data.value === data.data.mh1DocStatusDescr) {
      if (data.data.mh1DocStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.mh1DocStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.mh1DocStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if (data.data.mh3DocStatusDescr && data.value === data.data.mh3DocStatusDescr) {
      if (data.data.mh3DocStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.mh3DocStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.mh3DocStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if (data.data.m15DocStatusDescr && data.value === data.data.m15DocStatusDescr) {
      if (data.data.m15DocStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.m15DocStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.m15DocStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if (data.data.m15bDocStatusDescr && data.value === data.data.m15bDocStatusDescr) {
      if (data.data.m15bDocStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.m15bDocStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.m15bDocStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if ((data.data.lineStatusTitle && data.value === data.data.lineStatusTitle)
      || data.data.lineStatus === 5 || data.data.lineStatus === 6) {
      if (data.column.dataField === 'lineStatusTitle'
        && (data.data.lineStatus === 5 || data.data.lineStatus === 6)) {
        return (
          <ZDVLLineIcon data={data} />
        );
      }
      if (data.data.lineStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.lineStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.lineStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if (data.data.orderStatusTitle && data.value === data.data.orderStatusTitle) {
      if (data.data.orderStatus === 4) {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.orderStatus === 3) {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
      if (data.data.orderStatus === 2) {
        return (<div className={'colorMainDop'}><span>{data.value}</span></div>);
      }
    } else if (data.data.statusName && data.value === data.data.statusName) {
      if (data.data.statusName === 'Создано') {
        return (<div className={'colorGreen'}><span>{data.value}</span></div>);
      }
      if (data.data.statusName === 'Закрыто') {
        return (<div className={'colorRed'}><span>{data.value}</span></div>);
      }
    }
  }
  return (<div>{data.value}</div>);
};

/** Рендер поля "срок хранения" подсветка в зависимости от значения */
export const cellRenderStorageTimeCount = (data) => {
  if (typeof data.data.remainingTimeCount === 'number'
      && data.data.remainingTimeCount >= 0
      && data.data.remainingTimeCount <= 5
  ) {
    // try {
    //   if (data.cellElement) {
    //     data.cellElement.classList.add('td-red-cell-render');
    //   }
    // } catch (error) {
    //   console.log(error);
    // }

    return (<div className={'td-red-cell-render'}>{data.value}</div>);
  }
  return (<div className={'td-right-cell-render'}>{data.value}</div>);
};

/** Рендер поля "Сверх.норм.хранение" подсветка в зависимости от значения */
export const cellRenderStorageTimeCountOverdue = (data) => {
  if (typeof data.data.remainingTimeCount === 'number'
      && data.data.remainingTimeCount >= 0
  ) {
    return (<div className={'td-red-cell-render'}>{data.value}</div>);
  }
  return (<div className={'td-right-cell-render'}>{data.value}</div>);
};

export const cellRenderProhibition = (data) => {
  if (data.value === 'Запрет') {
    return (<div className={'td-red-cell-render'}>{data.value}</div>);
  }
  return (<div className={'td-right-cell-render'}>{data.value}</div>);
};

export const cellRenderContainerInspectedFlag = (data) => {
  if (!data.value) {
    return '';
  }
  return data.value === 'Y' ? 'Да' : 'Нет';
};

export const cellRenderInternalLt = (data) => {
  if(data.data.internalLt){
    const internalLtDate = Date.parse(data.data.internalLt);
    const currentDate = Date.now()
    const formattedDate = format(internalLtDate, 'dd.MM.yyyy');

    if(currentDate >= internalLtDate){
      return (<div className={'td-red-cell-render'}>{formattedDate}</div>);
    }

    return (<div className={'td-right-cell-render'}>{formattedDate}</div>);
  }
}

export const themeDark = () => window.localStorage.getItem('theme') === 'material.blue.dark';

export const getLocale = () => {
  let tLocale = localStorage.getItem('locale');
  if (!tLocale) {
    if (navigator.language === 'ru' || navigator.language === 'ru-RU') {
      localStorage.setItem('locale', 'ru');
      tLocale = 'ru';
    } else {
      localStorage.setItem('locale', 'en');
      tLocale = 'en';
    }
  }
  return tLocale;
};

export const normalizeDateToSend = (date) => {
  if (date) {
    const dates = cellRenderParseData({ value: date }).split('.');
    const [day, month, year] = dates;
    return `${year}-${month}-${day}`;
  }
  return date;
};
export const getCompatibleForm = (form) => {
  switch (form) {
    case 'NUM':
      return 'number';
    case 'FLAG':
      return 'checkbox';
    case 'DATE':
      return 'date';
    default:
      return 'text';
  }
};

export const isActive = (value) => value === 'Y';
export const boolValueFormatter = (value) => value ? 'Y' : 'N';

export function getRenderField({
  form,
  height,
  isValid = true,
  loading,
  onFocusIn,
  onOpened,
  plantId = '0',
  readonly = false,
  setState = null,
  state,
  stylingMode,
  validation = <></>,
  validationError = '',
  value = null,
  width,
  placeholder = ''
}) {
  if (loading) {
    return <LoadIndicator className="indicator" visible />;
  }
  if (form === 'number' || form === 'integer') {
    return (
      <NumberBox stylingMode="filled"
                 placeholder={placeholder}
                 value={+state}
                 onValueChanged={(e) => {
                   if (setState && e.value !== null) {
                     // eslint-disable-next-line no-restricted-globals
                     if (isNaN(e.value)) {
                       setState(0);
                     } else {
                       setState(e.value);
                     }
                   }
                   if (setState && e.value === null) {
                     setState(0)
                   }
                 }}
                 height={height || 45}
                 width={width || 300}
                 showClearButton
                 disabled={!setState && plantId !== '8200'}
                 isValid={isValid}
                 validationError={{ message: validationError }}
                 onFocusIn={onFocusIn}
                 readOnly={readonly}
      >
        {validation}
      </NumberBox>
    );
  }
  if (form === 'array') {
    return (
      <SelectBox
                 stylingMode="filled"
                 placeholder={placeholder}
                 items={state}
                 value={value}
                 onValueChanged={(e) => setState && setState(e.value)}
                 height={height || 45}
                 width={width || 300}
                 valueExpr={'value'}
                 displayExpr={'key'}
                 showClearButton
                 searchEnabled
                 disabled={!setState}
                 isValid={isValid}
                 validationError={{ message: validationError }}
                 onFocusIn={onFocusIn}
                 readOnly={readonly}
                 onOpened={onOpened}
                 elementAttr={{ class: style.userSelectBox }}
      >
        {validation}
      </SelectBox>
    );
  }
  if (form === 'checkbox') {
    return (
      <CheckBox
        value={isActive(state)}
        readOnly={readonly}
        onValueChanged={(e) => setState && setState(boolValueFormatter(e.value))}
       />
    );
  }
  if (form === 'date') {
    return (
      <DateBox
        value={state}
        displayFormat="dd.MM.yyyy"
        stylingMode="filled"
        placeholder={placeholder}
        onValueChanged={(e) => setState && setState(normalizeDateToSend(e.value))}
        showClearButton
        height={height || 45}
        width={width || 300}
        max={new Date()}
        readOnly={readonly}
       />
    );
  }
  return (
    <TextBox className={(height) ? 'dx-texteditor-input' : ''}
             value={state}
             stylingMode={stylingMode || 'filled'}
             placeholder={placeholder}
             width={width || 300}
             height={height || 45}
             onValueChanged={(e) => setState(e.value)}
             disabled={!setState}
             isValid={isValid}
             validationError={{ message: validationError }}
             onFocusIn={onFocusIn}
             readOnly={readonly}
    >
      {validation}
    </TextBox>
  );
}

// eslint-disable-next-line func-names
navigator.getBrowser = (function () {
  let sBrowser = 'unknown';
  const sUsrAg = navigator.userAgent;
  if (sUsrAg.indexOf('Firefox') > -1) {
    sBrowser = 'Mozilla Firefox';
  } else if (sUsrAg.indexOf('Opera') > -1) {
    sBrowser = 'Opera';
  } else if (sUsrAg.indexOf('Trident') > -1) {
    sBrowser = 'Microsoft Internet Explorer';
  } else if (sUsrAg.indexOf('Edge') > -1) {
    sBrowser = 'Microsoft Edge';
  } else if (sUsrAg.indexOf('Chrome') > -1) {
    sBrowser = 'Google Chrome or Chromium';
  } else if (sUsrAg.indexOf('Safari') > -1) {
    sBrowser = 'Apple Safari';
  }
  return sBrowser;
}());

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
  );
  return debouncedValue;
}

export function debounce(callback, wait) {
  let timeout;
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
}

export const cellRenderClosedStatus = (data) => {
  if (data.data.lineStatus === 4) {
    return (<div className={'colorRed'}><span>{data.value}</span></div>);
  }
  return (<div className={'td-right-cell-render'}>{data.value}</div>);
};

export const modalError = (textError, error, isToLogin) => (
  modalErrorOpen({
    message: (!textError)
      ? formatMessage('textError').unknownError
      : textError,
    techInfo: (!!error
      ? (!error.response.data.techInfo)
        ? `${formatMessage('textSupportPhone')} 8-800-200-69-39`
        : error.response.data.techInfo
      : `${formatMessage('textSupportPhone')} 8-800-200-69-39`),
    types: 'error',
    title: formatMessage('textError').warning,
    toLogin: isToLogin
  })
);

export function errorModalOpen(error) {
  const status = error?.response?.status;

  // if (status === 401) {
  //   return modalError(formatMessage('textError').unauthorized, error, true);
  // }

  if (status === 408) {
    return modalError(formatMessage('textError').requestTimeout, error, false);
  }

  if (status === 503) {
    return modalError(formatMessage('textError').serviceUnavailable, error, false);
  }

  if (status === 504) {
    return modalError(formatMessage('textError').gatewayTimeout, error, false);
  }
  if (error.response && error.response.data && status !== 401 && status !== 403) {
    return modalError(error.response.data.message, error, false);
  }
}

export function withSuspense(component) {
  return (
    <Suspense fallback={(<LoadPanel style={{ position: 'absolute', overflow: 'hidden' }} visible />)}>
      {component}
    </Suspense>
  );
}

export const cellRenderStockLevel = (data) => {
  if (!data.value) {
    return '';
  }
  switch (data.value) {
    case 10: {
      return 'Склад';
    }
    case 20: {
      return 'Зона';
    }
    case 30: {
      return 'Бокс';
    }
    default: {
      return '';
    }
  }
};

export const cellRenderVehicleType = (data) => {
  if (!data.value) {
    return '';
  }
  if (data.value === 1) {
    return formatMessage('textTN').auto;
  }
  if (data.value === 2) {
    return formatMessage('textTN').trailer;
  }
  return '';
};

export const validateVehicleNumber = (str, mode) => {
  const vehicleRegExp = /^[АВЕКМНОРСТУХавекмнорстух][0-9]{3}[АВЕКМНОРСТУХавекмнорстух]{2}[0-9]{2,3}$/;
  const trailerRegExp = /^[АВЕКМНОРСТУХавекмнорстух]{2}[0-9]{4}[0-9]{2,3}$/;
  if (str) {
    if (mode === 1) {
      return vehicleRegExp.test(str);
    }
    if (mode === 2) {
      return trailerRegExp.test(str);
    }
  }
  return false;
};

export const getVehicleNumPlaceholder = (mode) => {
  if (!mode) {
    return '';
  }
  if (mode === 1) {
    return 'A001AA999';
  }
  if (mode === 2) {
    return 'AA0000999';
  }
  return '';
};

export const getVehicleNumMask = (mode) => {
  if (!mode) {
    return '';
  }
  if (mode === 1) {
    return 'L000LL 000';
  }
  if (mode === 2) {
    return 'LL0000 000';
  }
  return '';
};

export const cellRenderDocumentType = (data) => {
  if (!data.value) {
    return '';
  }
  if (data.value === 1) {
    return formatMessage('textTN').passport;
  }
  if (data.value === 2) {
    return formatMessage('textTN').driverLicense;
  }
  return '';
};

export const getDriverDocumentNumMask = (mode) => {
  if (!mode) {
    return '';
  }
  if (mode === 1) {
    return '0000 000000';
  }
  if (mode === 2) {
    return '00 00 000000';
  }
  return '';
}

export const sortTabListByStockType = (
  tabListState,
  isRecyclingPf,
  isRecyclingGp,
  isConsignator,
  isExpeditor
) => {
  /** 0 - Наличие металла
   *  1 - Получение металла
   *  2 - Отчеты
   *  3 - Метрики по складу
   *  4 - Сканирование
   *  5 - Ответственные лица
   *  6 - Редактирование актов
   *  7 - Заказы на переработку
   *  8 - Производство
   *  9 - Балансировка отходов
   * 10 - Задания
   * 11 - Заказы
   * 12 - Работа с ТН */

  // Массив порядка вкладок
  let temp = [];

  // ГП
  if (isRecyclingGp) {
    temp = [8, 0, 2, 4, 3, 5];
  }
  // ПФ
  if (isRecyclingPf) {
    temp = [1, 0, 7, 10, 8, 9, 2, 6, 4, 3, 5];
  }

  // ответ хранение
  if (isConsignator) {
    temp = [1, 0, 2, 6, 3, 4, 5];
  }

  // экспедитор
  if (isExpeditor) {
    temp = [1, 0, 2, 4, 3, 5];
  }
  const specialTabs = tabListState.filter((tab) => !temp.includes(tab.id));
  const specialTabsIds = specialTabs.map((tab) => tab.id);
  /** Мы возвращаем отсортированные по нашему правилу значения,
   * но т.к. в массиве вкладок могут быть добавочные элементы
   * мы удаляем их из сортированного массива и переносим в конец
   * (иначе они будут находиться в начале массива)
   */
  return [
    ...tabListState.sort((a, b) => temp.indexOf(a.id) - temp.indexOf(b.id))
      .reduce((acc, val) => {
        if (!specialTabsIds.includes(val.id)) {
          acc.push(val);
        }
        return acc;
      }, []),
    ...specialTabs];
};

export const cellRenderRegisterFlag = (data) => !data.value ? 'Нет' : 'Да';

export const clearSavedSearchText = () =>
  window.localStorage.setItem('storage', JSON.stringify({ ...JSON.parse(window.localStorage.getItem('storage')), searchText: '' }));

export function includeInPeriod(start, end, date) {
  return (dayjs(end)
      .diff(dayjs(start)) >= 0)
    && ((dayjs(date)
        .diff(dayjs(start)) >= 0)
      && (dayjs(end)
        .diff(dayjs(date))) >= 0);
}

export function compare(a, b) {
  if (dayjs(a).diff(dayjs(b)) >= 0) {
    return 1;
  } else {
    return -1;
  }
}

export const isTestPlatform = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;
  return BASE_URL === ('http://localhost:3000' || 'https://mesus-test.kube.severstal.severstalgroup.com');

}

export const handleCookies = (() => {
  const cookieData = document.cookie.split(';').reduce((acc, c) => {
    const [cKey, cValue] = c.split('=');
    acc[cKey] = cValue;
    return acc;
  }, {})

  return {
    get: (key) => key ? cookieData[key] : document.cookie,
    update: (key, value) => {
      document.cookie = `${key}=${value}; path=/`
    }
  }
})();

